import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { StripeHeight } from '../../enums';
import { createDataTestId, nameof, px } from '../../utils';
import { createShouldForwardProp } from '../utils';
const StripeRoot = styled.hr.withConfig({
  shouldForwardProp: createShouldForwardProp([nameof('width'), nameof('height')])
}).withConfig({
  componentId: "ds__sc-1n4km78-0"
})(["width:", ";height:", ";border:0;margin:0;background:", ";"], _ref => {
  let {
    width
  } = _ref;
  return width ? px(width) : '100%';
}, _ref2 => {
  let {
    height
  } = _ref2;
  return height !== undefined && px(height);
}, props => props.theme.Stripe.background);
export function Stripe(_ref3) {
  let {
    height = StripeHeight.HEIGHT_6,
    testId,
    ...props
  } = _ref3;
  return React.createElement(StripeRoot, _extends({
    height: height
  }, createDataTestId(testId), props, {
    "data-component": "Stripe"
  }));
}